import { SubTitleAge } from "components/legal-age/components/style/text";
// import { UserData } from "contexts/session-context/session-reducer";
// import { TitleStart, SubTitleStart } from "views/start/text.style";

export const indio = {
  legalage: {
    title: ' '
  },
  agegate: {
    title: '¿Listo para ganar con Carta Blanca?',
    description: <div className="w-full flex flex-col items-center justify-center gap-3">
      <img className="" src={`${AZURE_BASE_URL}/agegate.png`} alt="PRODUCTOS CARTA BLANCA" />
      <SubTitleAge className="text-center">Ingrese su fecha de nacimiento<br /> para empezar.</SubTitleAge>
    </div>
  },
  signup: {
    title: 'Bienvenido',
    description: 'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.'
  },
  start: {
    signup: 'REGÍSTRATE CON CORREO',
    signin: 'ÉNTRALE CON CORREO',
    social: 'ENTRA CON:',
    title: {
      html:
        <div className="flex-1 w-full py-2 flex flex-col items-center justify-center">
          <img src={`${AZURE_BASE_URL}/fondo-inicial.svg`} className="w-full max-w-sm" alt="background" />
        </div>
    }
  },
  home: {
    title: <span className="bebasneue" style={{ color: '#008065' }}>¿QUÉ quieres hacer?</span>,
    description: '¡Complete sus datos!'
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿CÓMO SE LLAMA?',
          placeholder: 'Ponga su nombre aquí'
        },
        lastname: {
          placeholder: 'Ponga su apellido aquí',
        },
        nickname: {
          label: '¿APODO?',
          placeholder: '¿Como le gusta que le digan?'
        },
        gender: {
          label: '¿CÓMO SE IDENTIFICA?'
        }
      }
    },
    information: 'DATOS PERSONALES',
    address: 'DIRECCIÓN',
    contact: 'CONTACTO',
    button: 'IR A VER LAS TRIVIAS',
    identification: {
      nav: 'MI ROCK ID',
      title: 'ROCK ID',
      button: 'DESCARGAR ROCK ID'
    }
  },
  config: {
    prizes: '/trivias'
  },
  congrats: {
    range: {
      title: "NUEVO LOGRO DESBLOQUEADO",
      description: <></>,
      description2: <>Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.</>
    }
  },
  endroute: {
    title: <>¡Lo sentimos! <br /> Esto es solo <br /> para mayores</>,
    description: 'Vuelve cuando sea más grande.'
  },
  referrals: {
    description: 'Comparte tu código con amigos y gana más oportunidades de ganar.',
    subtitle: 'COMPARTE TU CÓDIGO Y GANA',
    left: 'COPIAR',
    right: 'COMPARTIR'
  },
  trivias: {
    congrats: '¡FELICIDADES',
    exit: {
      title: 'Si cancelas ahora pierdes y tiene que volver a empezar',
      subtitle: '¿Seguro que vamos por este camino?'
    },
    exchange: {
      button: {
        text: 'SEGUIR JUGANDO',
        url: '/trivias'
      }
    },
    triviaQr: {
      register: {
        title: <>CONTESTA<br /><span style={{ color: '#E89F38' }}>Y GANA</span></>,
        description: <><p>¿Ya tienes tu ROCK ID?</p><b>SI NO LO TIENES CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</b></>
      },
      late: {
        // title: (user: UserData) => `¡QUE PENA ${user?.firstName}!`,
        title: <>¡UPS! <br/> YA ES TARDE </>,
        description: <>
          Lamentablemente esta trivia ya no <br/> 
          está disponible. Estate atento <br/>  
          al nuevo bloque de horas de <br/>
          dinámicas en #INDIOVL2023 para <br/> 
          contestar una trivia nueva. <br/> 
          <div>
            <span className="mt-1 font-bold">BLOQUES DE HORAS:</span> <br/> 
            <span className="mb-3">
              11.30am - 1.30pm <br/> 
              1.30 pm - 3.30pm <br/> 
              3.30pm - 5.30pm <br/> 
              5.30pm - 7.30pm
            </span>
          </div>
          
        </>
      }
    }
  },
  tivias: {
    challenge: {
      modal: {
        description: '¿Seguro que quieres empezar a jugar? Una vez que des clic no hay vuelta atrás.'
      }
    }
  },
  survey: {
    title: 'CUÉNTANOS DE TI',
    button: 'RESPONDER'
  }
}